class InStoreAvailability extends window.BAO.CustomElement() {
  constructor () {
    super()

    // Elements
    this.trigger = this.externalEls.trigger?.element
    this.variantButtons = this.externalEls.variantButton?.elements

    // Data
    this.availabilityData = JSON.parse(this.dataset.availabilityData)

    if (this.trigger) {
      this.productFormId = this.trigger.dataset.productFormId
    }
  }

  setupListeners () {
    this.handleTrigger = this.handleTrigger.bind(this)

    if (this.trigger) {
      this.listeners.add(this.trigger, 'click', this.handleTrigger)
    }

    this.handleVariantButtonClick = this.handleVariantButtonClick.bind(this)
    this.variantButtons?.forEach((variantButton) => {
      this.listeners.add(variantButton, 'click', () =>
        this.handleVariantButtonClick(variantButton),
      )
    })
  }

  handleVariantButtonClick (variantButton) {
    // Retrieve the key for the relevant variant drawer
    const variantDrawerKey = variantButton.dataset.variantDrawerKey?.replace(
      '[product_form_id]',
      this.productFormId,
    )

    // Use the key to retrieve the relevant variant drawer trigger
    const variantDrawerTrigger = document.querySelector(
      `[data-drawers-trigger="${variantDrawerKey}"]`,
    )

    if (!variantDrawerTrigger) return

    setTimeout(() => {
      variantDrawerTrigger.click()
    }, 300)

    const handleDrawerClosed = (event) => {
      const drawerKey = event.detail?.drawerKey
      if (drawerKey === variantDrawerKey) {
        setTimeout(() => {
          this.trigger.click()
        }, 150)
        // Remove event listener so that drawer doesn't continue re-triggering availability drawer
        window.BAO.eventBus.removeEventListener(
          window.BAO.EVENTS.DRAWERS.CLOSED,
          handleDrawerClosed,
        )
      }
    }

    // Wait for the relevant drawer to be closed
    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.DRAWERS.CLOSED,
      handleDrawerClosed,
    )
  }

  handleTrigger () {
    this.checkAvailability()
  }

  checkAvailability () {
    const variantId = this.getCurrentVariantId()
    const variantData = this.availabilityData[variantId]
    if (!variantId || !variantData) {
      this.hideAllStoreData()
      this.hideNoResultsMessage(false)
      return
    }

    // Loop through each of the locations
    this.els.store?.elements.forEach((storeEl) => {
      const handle = storeEl.getAttribute('data-location-handle')
      const availability = variantData[handle] && variantData[handle] > 0

      this.updateStoreAvailability(storeEl, availability)
    })

    // Hide
    this.hideNoResultsMessage()
  }

  updateStoreAvailability (storeEl, availability) {
    storeEl.setAttribute('aria-hidden', false)

    const availableIcon = storeEl.querySelector(
      '[data-in-store-availability-el="icon-available"]',
    )
    const unavailableIcon = storeEl.querySelector(
      '[data-in-store-availability-el="icon-unavailable"]',
    )

    availableIcon?.setAttribute('aria-hidden', !availability)
    unavailableIcon?.setAttribute('aria-hidden', availability)
  }

  checkAvailabilityData () {
    // We check to see whether there's any valid data, and if not, we hide the trigger entirely
    if (!this.checkObjectForValues(this.availabilityData)) {
      this.trigger?.remove()
    }
  }

  checkObjectForValues (object) {
    for (const key in object) {
      if (Object.keys(object[key]).length > 0) {
        return true
      }
    }
    return false
  }

  hideAllStoreData (hide = true) {
    this.els.store?.elements.forEach((storeEl) => {
      storeEl.setAttribute('aria-hidden', hide)
    })
  }

  hideNoResultsMessage (hide = true) {
    this.els.noResults?.element.setAttribute('aria-hidden', hide)
  }

  getCurrentVariantId () {
    if (this.dataset.onlyDefaultVariantId) {
      // If the product is a single-variant product, the ID will be stored in a data attribute
      return this.dataset.onlyDefaultVariantId
    } else {
      // Otherwise, attempt to retrieve from the URL
      const url = new URL(window.location.href)
      return url.searchParams.get('variant')
    }
  }
}

if (!customElements.get('in-store-availability')) {
  customElements.define('in-store-availability', InStoreAvailability)
}
